









// @ts-nocheck

import Vue from "vue";
import { oAuth } from "../../../classes/Auth";
import { apiv1 } from "../../../libs/apiv1";

export default Vue.extend({
  data: () => ({
    selection: [],
    assigned: {},
    modulos: [
      {
        id: "FACTURACION",
        name: "Facturación",
        children: [
          {
            id: "FACTURACION_INICIO",
            name: "Inicio"
          },
          {
            id: "FACTURACION_PRECIOSPAGADOS",
            name: "Precios pagados"
          },
          {
            id: "FACTURACION_COMERCIALIZADORAS",
            name: "Comercializadoras"
          },
          {
            id: "FACTURACION_AHORROS",
            name: "Ahorros"
          },
          {
            id: "FACTURACION_COMPARATIVAPUNTO",
            name: "Comparativa por punto"
          },
          {
            id: "FACTURACION_COMPARATIVACIUDAD",
            name: "Comparativa por ciudad"
          },
          {
            id: "FACTURACION_REPORTEPUNTO",
            name: "Reporte por punto"
          }
        ]
      },
      {
        id: "HABITOS",
        name: "Habitos de consumo"
      },
      {
        id: "REALTIME",
        name: "Tiempo Real"
      }
    ]
  }),
  created() {
    this.getAssignedModules();
  },
  methods: {
    async getAssignedModules() {
      const { data } = await apiv1({
        url: `project/assigned-modules/${oAuth.getProject().id}`,
        method: "GET"
      });
      this.assigned = data;
      this.selection = data.modules;
    },
    async asignarModule() {
      let url = "project/assign-modules";
      let method = "POST";
      let _data = {
        proyecto: oAuth.getProject().id,
        modules: this.selection
      };

      if (this.assigned) {
        url = `${url}/${this.assigned._id}`;
        method = "PUT";
        delete _data.proyecto;
      }

      const { data } = await apiv1({
        "url": url,
        method: method,
        data: _data
      });
      this.getAssignedModules();
      this.$awn.success(data);
    }
  }
});
